"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "UploadSource", {
  enumerable: true,
  get: function get() {
    return _UploadSource["default"];
  }
});
var _UploadSource = _interopRequireDefault(require("./UploadSource"));